<template>
  <bcc-dialog :visible="show" width="500px" @close="handleCompanyDialog(false)">
    <h3>拒绝理由</h3>
    <div class="reason">{{ reason || '暂无理由' }}</div>
    <div slot="footer">
      <bcc-button @click="handleCompanyDialog(false)" size="middle" type="primary">确定</bcc-button>
    </div>
  </bcc-dialog>
</template>

<script>
export default {
  name: 'CompanyDialog',
  data: () => {
    return {
      show: false,
      reason: ''
    }
  },
  methods: {
    handleCompanyDialog(bol) {
      this.show = bol
    }
  },
}
</script>
<style scoped lang="scss">
.reason {
  margin-top: 15px;
}
</style>
